import React from 'react'
import ReactDOM from 'react-dom/client'
import App from './App'
import './styles.css'

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode><App /></React.StrictMode>,
)

if ('serviceWorker' in navigator && import.meta.env.PROD) {
  window.addEventListener('load', () => {
    navigator.serviceWorker.register('./sw.js').then(registration => registration.update())
    navigator.serviceWorker.addEventListener('controllerchange', () => {
      const reloadKey = 'bfs-sw-v56-draft-preview-reloaded'
      if (!window.sessionStorage.getItem(reloadKey)) {
        window.sessionStorage.setItem(reloadKey, 'true')
        window.location.reload()
      }
    })
  })
}
